/**
 * Redux slice for the Centralised PT Plan feature.
 * Isolated from plansSlice so it can be added/removed without affecting other state.
 */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPtPlanDrafts, fetchPtPlanMappedGyms } from "./ptPlansApis";

export const fetchPtPlanDraftsData = createAsyncThunk(
  "ptPlans/fetchPtPlanDraftsData",
  async (payload) => {
    const { filters, token } = payload;
    return await fetchPtPlanDrafts(filters, token);
  }
);

export const fetchPtPlanMappedGymsData = createAsyncThunk(
  "ptPlans/fetchPtPlanMappedGymsData",
  async (payload) => {
    const { draft_uid, token } = payload;
    return await fetchPtPlanMappedGyms(draft_uid, token);
  }
);

const ptPlansSlice = createSlice({
  name: "ptPlans",
  initialState: {
    ptDrafts: null,
    ptDraftsLoading: false,
    ptDraftsError: null,

    mappedGyms: null,
    mappedGymsLoading: false,
    mappedGymsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPtPlanDraftsData.pending, (state) => {
        state.ptDraftsLoading = true;
        state.ptDraftsError = null;
      })
      .addCase(fetchPtPlanDraftsData.fulfilled, (state, action) => {
        state.ptDraftsLoading = false;
        state.ptDrafts = action.payload;
      })
      .addCase(fetchPtPlanDraftsData.rejected, (state, action) => {
        state.ptDraftsLoading = false;
        state.ptDraftsError = action.error.message;
      })

      .addCase(fetchPtPlanMappedGymsData.pending, (state) => {
        state.mappedGymsLoading = true;
        state.mappedGymsError = null;
      })
      .addCase(fetchPtPlanMappedGymsData.fulfilled, (state, action) => {
        state.mappedGymsLoading = false;
        state.mappedGyms = action.payload;
      })
      .addCase(fetchPtPlanMappedGymsData.rejected, (state, action) => {
        state.mappedGymsLoading = false;
        state.mappedGymsError = action.error.message;
      });
  },
});

export default ptPlansSlice.reducer;
